import { DEFAULT_DATE_FILTERS } from "../../../constants";
import RangePicker from "../RangePicker";
import styles from "./styles.module.css";


/**
 * Date filter: calendar range picker with quick options and EXPORT button.
 */
const DateFilterContent = ({
  onFilterDate,
  onClose,
  dateFilters = DEFAULT_DATE_FILTERS,
  selectedDate,
}) => (
  <div className={styles.dateFilterContent}>
    <RangePicker
      isOpen={true}
      showDirectPicker={true}
      setIsOpen={onClose}
      onFilterDate={(startDate, endDate) => {
        onFilterDate?.(startDate, endDate);
        onClose?.();
      }}
      dateFilters={dateFilters}
      noClearBtn={true}
      rangeValue={
        selectedDate?.startDate && selectedDate?.endDate
          ? [selectedDate.startDate, selectedDate.endDate]
          : []
      }
    />
  </div>
);

export default DateFilterContent;
